<template>
  <div>
    <h2>Sloty</h2>
    <v-row v-if="company && operation">
      <v-col cols="12" lg="3">
        Wdrożenie: {{ company.name }}
      </v-col>
      <v-col cols="12" lg="3">
        Kolejka: {{ operation.queueName }}
      </v-col>
      <v-col cols="12" lg="3">
        Operacja: {{ operation.operationName }}
      </v-col>
    </v-row>
    <v-tabs>
      <v-tab>
        Kalendarz
      </v-tab>
      <v-tab>
        Tabela
      </v-tab>
      <v-tab-item>
        <calendar :events="events" @clickEvent="clickEvent">
          <template v-slot:middleRow>
            Oznaczenia kolorów:
            <v-chip class="mr-2" color="primary">Tymczasowa blokada</v-chip>
            <v-chip class="mr-2" color="success">Wolny slot</v-chip>
            <v-chip class="mr-2" color="error">Rezerwacja</v-chip>
          </template>
        </calendar>
      </v-tab-item>
      <v-tab-item>
        <data-table :headers="headers" :items="slots"
                      @click:row="detailsDialog=true; detailsSlot = $event">
          <template v-slot:item.dateTime="{item}">
            {{ moment(item.dateTime).format("YYYY-MM-DD HH:mm") }}
          </template>
        </data-table>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="detailsDialog" :width="800">
      <v-card v-if="detailsSlot">
        <v-card-title>Szczegóły slotu</v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="d-flex">
              <span class="mt-auto mb-auto">Id slotu: {{ detailsSlot.id }}</span>
            </v-col>
            <v-col class="d-flex">
              <span class="mt-auto mb-auto">Data rezerwacji:
                {{ moment(detailsSlot.dateTime).format("YYYY-MM-DD HH:mm") }}
              </span>
            </v-col>
            <v-col class="d-flex">
              <div class="mt-auto mb-auto">
                <span class="mr-2">Status:</span>
                <span v-if="getSlotStatus(detailsSlot) === 'FREE'"><v-chip color="success">Wolny</v-chip></span>
                <span v-if="getSlotStatus(detailsSlot) === 'BUSY'"><v-chip color="error">Rezerwacja</v-chip></span>
                <span v-if="getSlotStatus(detailsSlot) === 'BLOCK'"><v-chip
                    color="primary">Blokada czasowa</v-chip></span>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="detailsSlot.reservationId">
            <v-col>
              Data blokady: {{ moment(detailsSlot.blockedDateTime).format("YYYY-MM-DD HH:mm:ss") }}
            </v-col>
            <v-col>
              Id rezerwacji: {{ detailsSlot.reservationId }}
            </v-col>
            <v-col>
              Potwierdzony: {{ detailsSlot.confirmed ? "tak" : "nie" }}
            </v-col>
          </v-row>
          <v-row v-if="detailsSlot.confirmed">
            <v-col>
              Kod aktywacji: {{ detailsSlot.activatedCode }}
            </v-col>
            <v-col>
              IP klienta: {{ detailsSlot.confirmIp }}
            </v-col>
            <v-col>

            </v-col>
          </v-row>
          <v-row v-if="detailsSlot.reservationId">
            <v-col v-html="getSlotPropertiesToDisplay(detailsSlot)">
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="detailsSlot.confirmed">
          <v-btn color="primary" disabled>Wygeneruj ponownie mail z potwierdzeniem (TODO)</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Calendar from "@/components/Calendar";

export default {
  components: {
    Calendar
  },
  data() {
    return {
      detailsDialog: false,
      detailsSlot: null,
      headers: [
        {
          text: 'Id',
          value: "id"
        },
        {
          text: "Data",
          value: "dateTime",
          width: 150
        },
        {
          text: "Id rezerwacji",
          value: "reservationId"
        },
        {
          text: "Potwierdzony",
          value: "confirmed"
        },
        {
          text: "Kod aktywacji",
          value: 'activatedCode'
        },
        {
          text: "IP",
          value: "confirmIp"
        },
        {
          text: "Data potwierdzenia",
          value: "confirmedDateTime"
        },
        {
          text: "Dane rezerwacji",
          value: 'connectedProperties'
        }
      ],
      slots: [],
      operation: null,
      company: null
    }
  },
  computed: {
    operationId() {
      return this.$route.params.operationId
    },
    companyId() {
      return this.$route.params.companyId
    },
    events() {
      return this.slots.map(el => {
        let color = 'primary';
        let name = 'blokada'
        if (el.reservationId) {
          if (el.confirmed) {
            name = 'rezerwacja'
            color = 'error'
          } else {
            name = 'blokada'
            color = 'primary'
          }
        } else {
          name = 'wolny'
          color = 'success'
        }
        return {
          name: name,
          start: el.dateTime,
          end: el.dateTime,
          slotId: el.id,
          color: color
        }
      })
    }
  },
  methods: {
    getSlotPropertiesToDisplay(slot) {
      let string = '';
      slot.properties.forEach(prop => {
        string += '<div class="row"><div class="col">' + prop.name + ': ' + prop.value + '</div></div>'
      })
      return string;
    },
    getSlotStatus(slot) {
      if (!slot.reservationId) {
        return "FREE"
      }
      if (slot.confirmed) {
        return "BUSY"
      }
      return "BLOCK"
    },
    clickEvent(event) {
      let slot = this.slots.find(el => el.id === event.event.slotId);
      if (slot) {
        this.detailsSlot = slot;
        this.detailsDialog = true;
      }
    },
  },
  mounted() {
    let vm = this;
    vm.$http.get("Company/GetCompany?id=" + vm.companyId).then(response => {
      vm.company = response.data;
    })
    vm.$http.get("Operation/GetOperation?operationId=" + vm.operationId).then(response => {
      vm.operation = response.data;
      vm.$http.get("Slot/GetSlots?operationId=" + vm.operationId).then(response => {
        vm.slots = response.data;
      })
    });
  }
}
</script>
